import React from 'react';

interface FooterProps {
  className?: string;
  style?: React.CSSProperties;
}

const Footer: React.FC<FooterProps> = ({ className = '', style }) => {
  return (
    <footer className={`nf-footer nf-footer-small${className ? ` ${className}` : ''}`} style={style}>
      &copy; {new Date().getFullYear()} NeutralFit. All rights reserved.
    </footer>
  );
};

export default Footer;
